import { render, staticRenderFns } from "./collection-page.vue?vue&type=template&id=4c57a692"
import script from "./collection-page.vue?vue&type=script&lang=js"
export * from "./collection-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c57a692')) {
      api.createRecord('4c57a692', component.options)
    } else {
      api.reload('4c57a692', component.options)
    }
    module.hot.accept("./collection-page.vue?vue&type=template&id=4c57a692", function () {
      api.rerender('4c57a692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EndUserViews/Collections/collection-page.vue"
export default component.exports